/**
 * Dynamic Navigation
 *  We build the navbar links as we encouter the matching floors :
 *  - Directly for '.non-async-container' elements
 *  - When we receive a 'async-content:loaded' cube.event -- triggered by lib-lazyload.js
 *    This event give us the loaded floor, allowing us to display the related navbar link (linked by the floor.id)
 */

export function init() {
  // Display non-async floor links
  cube.$$(`.non-async-container`).forEach(displayNonAsyncNavLinks);

  // Display async floor links when floor is loaded
  cube.event.on('async-content:loaded', displayAsyncNavLinks);

  // Smooth scroll to floor on nav link click
  cube.$$('.description-product-nav').delegate('click', 'li a', clickInternalNavigation);

  // when click on navigation tab, if a floor is lazy-loaded, reclick on it after it's loaded
  cube.event.on('async-content:loaded', fakeClick);

  // When click on question & answer in product detail, scroll to question & answer floor
  const QAbutton = cube.$('.product-question-answer a');
  if (QAbutton) {
    QAbutton.on('click', event => {
      event.preventDefault();
      const innerNavQAButton = cube.$('.description-product-nav--visible a[href="#QuestionAndAnswerFloor"]');
      if (innerNavQAButton) innerNavQAButton.click();
    });
  }

  // reset after model change
  cube.event.on('modelChanged', afterModelChange);
}





/**
 * Update navigation after model changes
 */
function afterModelChange() {
  // Need a timeout cause if the floor is not empty before the model change, it need time to "clear"
  setTimeout(() => {
    cube.$$(`.non-async-container`).forEach(displayNonAsyncNavLinks);
  }, 200);
}





/**
 * Make nav link visible for floors that are not lazy-loaded:
 *  - if not empty : make the link appear in navbar
 */
function displayNonAsyncNavLinks(floor) {
  const floorId = floor.id || null;
  const floorLink = cube.$(`.description-product-nav li a[href="#${floorId}"]`) || null;
  const listItem = floorLink ? floorLink.closest('li') : null;

  if (listItem && floor) {
    // If the floor contains something
    if (
      floor.$('.floor-svelte') ||
      floor.innerHTML.length > 0 &&
      floor.$('.floor-content-holder') &&
      floor.$('.floor-content-holder').clientHeight > 0
    ) {
      listItem.classList.add('description-product-nav--visible');
    }
    else {
      listItem.classList.remove('description-product-nav--visible');
    }
  }
}

/**
 * Make nav link visible for floors that are lazy-loaded
 *  The link appear after floor is loaded.
 */
function displayAsyncNavLinks(floor) {
  const floorId = floor.id || null;
  const floorLink = cube.$(`.description-product-nav li a[href="#${floorId}"]`) || null;
  const listItem = floorLink ? floorLink.closest('li') : null;

  if (listItem) {
    listItem.classList.remove('async-anchor');
    listItem.classList.add('description-product-nav--visible');
  }
}

/**
 * When user click on a navlink, we smoothly scroll to the floor and remember the last clicked item
 */
let clickedLink = null;
function clickInternalNavigation(event) {
  event.preventDefault();
  event.stopPropagation();

  clickedLink = event.target;

  const floor = cube.$(clickedLink.getAttribute('href'));
  srollToFloor(floor);
}

/**
 * When a floor is lazy-loaded, we check if a link was previously clicked
 * If so, we wait the complete load of the floor
 * If the new floor is above the clicked floor, we trigger a new click on the clicked item to focus on it
 */
function fakeClick(floor) {
  if (floor && clickedLink){

    const newFloorOffsetTop = floor.getBoundingClientRect().top + window.scrollY;
    const previousClickedFloor = cube.$(clickedLink.getAttribute('href'));
    const previousClikedFloorOffsetTop = previousClickedFloor.getBoundingClientRect().top + window.scrollY;

    if (newFloorOffsetTop < previousClikedFloorOffsetTop){
      srollToFloor(previousClickedFloor);
    }

    clickedLink = null;
  }
}






/**
 * Calculate the header and navbar height to set the offset and smooth scroll to the floor
 */
function srollToFloor(floor) {
  const headerHeight = Math.max(cube.$id('header').offsetHeight, cube.$id('product-head').offsetHeight);
  const navbarHeight = cube.$id('internal-navigation').offsetHeight;

  cube.ui.smoothScroll(floor, { offset: -(headerHeight + navbarHeight) });
}



// WEBPACK FOOTER //
// ./src/catalog/product-details/internal-navigation.js